import { AuthProvider, useAuth } from './context/AuthContext';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/jobs/auth/Login';
import Register from './components/auth/jobs/auth/Register';
import JobForm from './components/auth/jobs/jobs/JobForm';
import JobList from './components/auth/jobs/jobs/JobList';
import { JSX } from 'react';
import JobResults from './components/auth/jobs/jobs/JobResults';
import MainLayout from './components/auth/jobs/layout/MainLayout';
import { CustomThemeProvider } from './context/ThemeContext';
import AboutPage from './components/auth/jobs/common/AboutPage';
import Settings from './components/auth/jobs/auth/Settings';
import FAQ from './components/auth/jobs/common/FAQ';


function App() {
  return (
    <BrowserRouter>
      <CustomThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/" element={
              <PrivateRoute>
                <MainLayout>
                  <JobForm />
                </MainLayout>
              </PrivateRoute>
            } />
            <Route path="/jobs" element={
              <PrivateRoute>
                <MainLayout>
                  <JobList />
                </MainLayout>
              </PrivateRoute>
            } />
            <Route path="/job/:id/comments" element={
              <PrivateRoute>
                <MainLayout>
                  <JobResults />
                </MainLayout>
              </PrivateRoute>
            } />
            <Route path="/about" element={
              <PrivateRoute>
                <MainLayout>
                  <AboutPage />
                </MainLayout>
              </PrivateRoute>
            } />
            <Route path="/settings" element={
              <PrivateRoute>
                <MainLayout>
                  <Settings/>
                </MainLayout>
              </PrivateRoute>
            } />
            <Route path="/faq" element={
              <PrivateRoute>
                <MainLayout>
                  <FAQ/>
                </MainLayout>
              </PrivateRoute>
            } />
          </Routes>
        </AuthProvider>
      </CustomThemeProvider>
    </BrowserRouter>
  );
}

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuth();

  if (loading) {

    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};


export default App;